
import API from "@api/index.js";
import Constant from "@constant/index.js";
import { $util } from "@util/util.js";
require("@util/myCarousel.js");

export default class Recommend{
    constructor(){
        this._data = null;
    }

    analysis(data){
        let res = [];
        let goodsDetails = data?.goodsDetails || {};
        const recommedResult = data?.recommedResult?.recommList || [];
        recommedResult?.forEach((code, index) => {
            const goods = goodsDetails?.[code]?.detail || {};
            if(goodsDetails?.[code]?.detail){
                goods.position = index;
                goods.strategy = data?.recommedResult?.flag;
                goods.goodsCode = code;
                goods.price = goodsDetails?.[code]?.price;
                res.push(JSON.parse(JSON.stringify(goods)));
            }
        });
        return res;
    }
    getCartGoodsCodes() {
        // 方式1: 获取所有可购买商品的 goodsCode
        try {
            const mainSkus = $util.getPurchaseEnabledMainSkus(_engine._group);
            return mainSkus.map(item => item.goodscode);
        } catch(e){
            return [];
        }
        
        // 方式2: 如果需要获取所有商品（包括不可购买的），使用：
        // const allItems = $util.getAllItems(_engine._group, false);
        // return allItems.map(item => item._id);
    }

    init(){
        const goodsCodes = this.getCartGoodsCodes();
        let params = {
            shopid:_shopId,
            scenario:'cart',
            terminal:_terminal,
            uid2: goodsCodes?.join(',')
        }
        if(!$util.isPC()) {
            delete params['uid2'];
        }
        /*let _uid =(passport && passport.cookie && passport.cookie.lenovoId)?passport.cookie.lenovoId :"";
        let params = {
            shopid: window._shopId,
            terminal: window._terminal,
            scenario: 'cart_guesslike_recm',            
            source: (window._terminal == Constant.TERMINAL.PC) ? 'S0001001' :"S0001003",
            uidType: 'IT0000001',
            uid: _uid            
        }*/

        
        return API.recommend(params);
    }
}